
import api from '@/api/proxyWeb/factures'

export default {

    get({ commit }, id) {

        commit('setCurrentFacture', null)
        
        return api.get(id)
            .then(facture => {
                commit('setCurrentFacture', facture)
            })
    },

    getAll({ commit, rootState }) {

        commit('setFactures', null)
        
        let params = {
            client_id: rootState.clients.currentId
        }

        return new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, factures ]) => {
                commit('setCount', count)
                commit('setFactures', factures)
                resolve(factures)
            })
        })
    },

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(factures => {
                commit('setNextFactures', factures)
            })
    }
}